import React, { useState, useEffect } from "react";
import { FaEye, FaDownload, FaFileInvoice } from "react-icons/fa";

const MobilePDFView = ({ pdfUrl, fileName }) => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth >= 768);
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.card,
          maxWidth: isTablet ? "480px" : "360px",
          padding: isTablet ? "32px 28px" : "26px 20px",
        }}
      >
        {/* Icon */}
        <div style={styles.iconWrapper}>
          <FaFileInvoice size={22} color="#fff" />
        </div>

        {/* Title */}
        <h2 style={styles.title}>Invoice Ready</h2>
        <p style={styles.subtitle}>
          Your invoice has been generated successfully
        </p>

        {/* Buttons */}
        <div style={styles.buttonGroup}>
          {/* Preview */}
          <button
            onClick={() => window.open(pdfUrl, "_blank")}
            style={{ ...styles.button, ...styles.previewBtn }}
          >
            <FaEye /> Preview
          </button>

          {/* Download */}
          <a
            href={pdfUrl}
            download={fileName}
            style={{
              flex: 1,
              textDecoration: "none",
              border: "none",
              outline: "none",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            <button
              style={{ ...styles.button, ...styles.downloadBtn }}
            >
              <FaDownload /> Download
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",
    background:
      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  },

  card: {
    width: "100%",
    background: "rgba(255,255,255,0.9)",
    backdropFilter: "blur(10px)",
    borderRadius: "18px",
    textAlign: "center",
    boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
  },

  iconWrapper: {
    width: "52px",
    height: "52px",
    margin: "0 auto 16px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #0d6efd, #4dabf7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 6px 15px rgba(13,110,253,0.4)",
  },

  title: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#222",
    marginBottom: "6px",
  },

  subtitle: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "24px",
  },

  buttonGroup: {
    display: "flex",
    gap: "12px",
  },

  button: {
    flex: 1,
    padding: "12px",
    border: "none",
    outline: "none",
    borderRadius: "12px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.25s ease",
  },

  previewBtn: {
    background: "#ffffff",
    color: "#0d6efd",
    border: "1px solid #d0d7ff",
  },

  downloadBtn: {
    background: "linear-gradient(135deg, #198754, #20c997)",
    color: "#fff",
    boxShadow: "0 6px 15px rgba(25,135,84,0.3)",
  },
};

export default MobilePDFView;